import api from '../api';

export class SubscriptionDetailsService {
  static async getSubscriptionDetails(payload: any) {
    const {
      page,
      rowsPerPage,
      id,
    } = payload;
    const apiEndPoint = `limit=${rowsPerPage}&pageNo=${page + 1}&userId=${id}`;
    return api.getApiCall(`/api/v1/admins/subscribed-users/details?${apiEndPoint}`);
  }
}